import { store } from '@/store/store';
import { qr_scans } from '@/shared/dtos/qr_scans';
import {
    VuexModule,
    Mutation,
    getModule,
    Module,
    Action
} from 'vuex-module-decorators';
import { ssmHttpService } from '@/shared/services/http-service';
import { API } from '@/shared/api';

@Module({
    namespaced: true,
    name: 'qr_scansModule',
    store,
    dynamic: true
})
class qr_scansModule extends VuexModule {
    public qr_scanses: qr_scans[] = [];
    public qr_scans: qr_scans = new qr_scans();

    @Action({ commit: 'onGetqr_scanses' })
    public async getqr_scanses() {
        return await ssmHttpService.get(API.qr_scans);
    }

    @Action({ commit: 'onGetqr_scans' })
    public async getqr_scans(id: any) {
        return await ssmHttpService.get(API.qr_scans + '/' + id);
    }
    @Action({ commit: 'onGetqr_scanses' })
    public async getqrsCode(code: string) {
        return await ssmHttpService.get(API.qr_scans + '/code/' + code);
    }

    @Action
    public async guardarqr_scans(qr_scans: qr_scans) {
        /*toJson() no existe pero existe en la extends de BaseDto*/
        return await ssmHttpService.post(API.qr_scans, qr_scans.toJson());
    }

    @Action
    public async modificarqr_scans(qr_scans: qr_scans) {
        return await ssmHttpService.put(API.qr_scans + '/' + qr_scans.id, qr_scans);
    }

    @Action
    public async eliminarqr_scans(qr_scans: qr_scans) {
        return await ssmHttpService.delete(API.qr_scans + '/' + qr_scans.id, null, false);
    }

    @Mutation
    public onGetqr_scanses(res: qr_scans[]) {

        this.qr_scanses = res ? res.map((x) => new qr_scans(x)) : []
    }

    @Mutation
    public onGetqr_scans(res: qr_scans) {
        this.qr_scans = new qr_scans(res);
    }

}
export default getModule(qr_scansModule);